<template>
    <nav 
        :class="[
            'navbar', 
            'navbar-expand',
            'navbar-fixed-top',
            'navbar-dark',
            'bg-dark',
            'page-margin',
            'p-0',
            'rounded-bottom'
        ]"
    >
    <div class="container-fluid p-0">
        <a class="navbar-brand p-0">
            <router-link to="/" class="navbar-brand">
                <img 
                    id="nav-bar-logo"
                    src="@/assets/card.png" 
                    alt="Logo"
                    class="img-fluid"
                >
            </router-link>
        </a>
        <ul class="navbar-nav mx-auto" style="font-family: 'Roboto', sans-serif;">
            <li>
                <router-link
                    to="/"
                    class="nav-link"
                    active-class="active"
                    aria-current="page"
                    :title="`Voltar ao Início`"
                >
                    Início
                </router-link>
            </li>
            <li>
                <router-link
                    to="/sobre"
                    class="nav-link"
                    active-class="active"
                    aria-current="page"
                    :title="`Sobre a Empresa`"
                >
                    Sobre Nós
                </router-link>
            </li>
            <li>
                <router-link
                    to="/contato"
                    class="nav-link"
                    active-class="active"
                    aria-current="page"
                    :title="`Contate-nos!`"
                >
                    Contato
                </router-link>
            </li>
        </ul>
        <form class="d-flex">
            <button
                type="button"
                class="btn btn-primary light-text" 
                @click.prevent="goToLogin"
            >
            <i class="bi bi-person-check-fill"></i> Login
            </button>
        </form>
    </div>
    </nav>
</template>

<script>
export default {
    data() {
        return {
            pages: []
        };
    },
    methods: {
        goToLogin() {
            this.$router.push('/login');
        }
    }
}
</script>

<style scoped>
.navbar {
    background-color: #42413f !important;
    min-width: max-content;
}
.navbar-brand { 
    width: 180px; /* "Conserta" centralização dos itens */
}

ul.navbar-nav {
    gap: 20px;
    font-weight: bold;
}

ul.navbar-nav li a {
    border-radius: 5px;
}
ul.navbar-nav li a:hover {
    background-color: #5a5a5a; /* Cor ligeiramente mais clara */
}

button.btn-primary {
    width: 100px;
    margin-right: 10px;
    font-weight: bold;
    background-color: #003867;
    border-color: #003867;
}
button.btn-primary:hover{
    background-color: #ffd700;
    border-color: #ffd700;
}
</style>